import {createSlice} from '@reduxjs/toolkit';

const mp_infoSclice = createSlice({
    name: 'mp_info',
    initialState: {
        loading: false,
        home: [],
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setMp_info_home: (state, action) => {
            state.home = action.payload
        },
    },
});

export const { 
    setLoading,
    setMp_info_home
} = mp_infoSclice.actions
export default mp_infoSclice.reducer;